module.exports = __webpack_public_path__ + "img/driver_available.d410e29a.svg";